import axios from "axios/index";
import { API } from "../utilities/api.config";

function loadUiConfigs() {
  return (dispatch) => {
    dispatch({
      type: "LOAD_UI_CONFIGS",
      payload: {
        mainNavOpened: localStorage.getItem("wbiNavBarOpened") === "true",
      },
    });
  };
}

function setAddClientNav(visible = false) {
  return (dispatch) => {
    dispatch({
      type: "SET_ADD_CLIENT_NAV",
      payload: visible,
    });
  };
}

function setAdminNav(visible = false) {
  return (dispatch) => {
    dispatch({
      type: "SET_ADMIN_NAV",
      payload: visible,
    });
  };
}

function setEducationNav(visible = false) {
  return (dispatch) => {
    dispatch({
      type: "SET_EDUCATION_NAV",
      payload: visible,
    });
  };
}

function setPortfolioNav(visible = false) {
  return (dispatch) => {
    dispatch({
      type: "SET_PORTFOLIO_NAV",
      payload: visible,
    });
  };
}

function setDigitalOnboardingNav(visible = false) {
  return (dispatch) => {
    dispatch({
      type: "SET_DO_NAV",
      payload: visible,
    });
  };
}

function setUsersNav(visible = false) {
  return (dispatch) => {
    dispatch({
      type: "SET_USER_NAV",
      payload: visible,
    });
  };
}

function showCalculatingState(visible = true) {
  return (dispatch) => {
    if (visible) {
      dispatch({
        type: "SHOW_CALCULATING_STATE",
        payload: visible,
      });
    } else {
      setTimeout(() => {
        dispatch({
          type: "SHOW_CALCULATING_STATE",
          payload: visible,
        });
      }, 1000);
    }
  };
}

function toggleMainNav(nextState, updateLocalStorage = true) {
  if (updateLocalStorage) {
    localStorage.setItem("wbiNavBarOpened", nextState);
  }
  return (dispatch) => {
    dispatch({
      type: "TOGGLE_MAIN_NAV",
      payload: nextState,
    });
  };
}

function updateProgressStep(step) {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_PROGRESS_STEP",
      payload: step,
    });
  };
}

// Function to get the app's custom configuration by client ID
function getCustomConfiguration() {
  return (dispatch) => {
    dispatch({
      type: "CUSTOM_CONFIGURATION_FETCH_REQUESTED",
    });
    axios
      .get(`${API.GET_CUSTOM_CONFIGURATION_BY_CLIENT_ID}`)
      .then((response) => {
        dispatch({
          type: "SET_APP_CUSTOM_CONFIGURATION",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "CUSTOM_CONFIGURATION_FETCH_FAIL",
          payload: error,
        });
        if (error.response.status === 401) {
          dispatch({
            type: "LOGOUT",
          });
        }
      });
  };
}

function toggleHelpWidget(nextState, updateLocalStorage = true) {
  if (updateLocalStorage) {
    localStorage.setItem("helpWidgetOpened", nextState);
  }
  return (dispatch) => {
    dispatch({
      type: "TOGGLE_HELP_WIDGET",
      payload: nextState,
    });
  };
}
export const appAction = {
  loadUiConfigs,
  setAddClientNav,
  setAdminNav,
  setEducationNav,
  setPortfolioNav,
  setDigitalOnboardingNav,
  setUsersNav,
  showCalculatingState,
  toggleMainNav,
  updateProgressStep,
  getCustomConfiguration,
  toggleHelpWidget,
};

export default appAction;



// WEBPACK FOOTER //
// ./src/actions/app.action.js